import momentJalaali from "moment-jalali";
import { faTable } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, ButtonGroup, ButtonToolbar, Card, Col, Form, FormControl, FormGroup, OverlayTrigger, Popover, Row, Table } from "react-bootstrap";
import { getExtAttrSettings, getExtAttrSettingsForSearch, getSystemSettings } from "../store/api/SystemSettingsAPI";
import { useDispatch, useSelector } from "react-redux";
import BihamtaTable from "../../Components/BihamtaTable";
import { getReportGeneratorReportData, getServiceStatusList, saveReportGeneratorTemplate, deleteReportGeneratorTemplate, getReportGeneratorTemplates } from "../store/api/Services";
import { BarChart, BorderAll, BorderStyle, Check2, ColumnsGap, Download, FileEarmarkExcelFill, Front, List, Printer, Search, Trash } from "react-bootstrap-icons";
import { exportToExcel, InfoTypes, isWebApp, keyIsLetterOrNumber, setDialog, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import Loader from "react-loader-spinner";
import { getStageList } from "../../Office/store/api/FlowAPI";
import { searchProductBug } from "../store/api/TaskDetailsApi";
import { getBaseInfoList } from "../../BaseInfo/store/api/BaseInfoApi";
import { getAllProductMainGroups, getAllProductTypes, getProductGroups } from "../store/api/GetAllProduct";
import { getAllGuaranteeHolders } from "../store/api/GuaranteeApi";
import { useForm } from "react-hook-form";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import DatePicker from "react-datepicker2";
import { getAllProvinces, getCityList } from "../store/api/LocationAPI";
import BihamtaMultiSelect from "../../Components/BihamtaMultiSelect";
import { getPageFieldList, getUserList } from "../store/api/Users";
import ModalPrintViewer from "../../Components/Modals/ModalPrintViewer";

export default function ReportGenerator() {
    const frmFilters = useRef();
    const tblResult = useRef();
    let reportTilesArray = useRef([]);
    const tblReportCols = useRef();
    const dispatch = useDispatch();
    const selectOrderBy = useRef();
    const divReportTiles = useRef();
    const isMobile = useIsMobileApp();
    const inputReportTitle = useRef();
    const selectedPhaseList = useRef([]);
    const selectedStatusList = useRef([]);
    const { handleSubmit, register } = useForm();
    const [pending, setPending] = useState(false);
    const settingNames = ['ProductGrouppingType'];
    const [stageList, setStageList] = useState(null);
    const [reportResult, setReportResult] = useState();
    const [holders, setProductHolders] = useState([]);
    const [productTypes, setProductTypes] = useState([]);
    const [selectedStaff, setStaffData] = useState(null);
    const [reportTemplates, setReportTemplates] = useState();
    const [popStaff, setPopStaff] = useState({ show: false });
    const [selectedRefStaff, setRefStaffData] = useState(null);
    const [showMenuButton, setShowMenuButton] = useState(false);
    const [modalPrintData, setModalPrintData] = useState({ show: false });

    const [considerDescList, setConsiderDescList] = useState(null);
    const { serviceStatusList, systemSettings, serviceExtraAttrSettings, provinceList, cityList, filterData, fieldList, productBugs, usersList, mainPGList, pgList } = useSelector(state => {
        return {
            productBugs: state.ProductReducer.productBugList?.Data,
            serviceStatusList: state.service.serviceStatusList,
            systemSettings: state.SystemSettingsReducer.systemSettings,
            serviceExtraAttrSettings: state.SystemSettingsReducer.serviceExtraAttrSettingsForSearch,
            provinceList: state.locationDataReducer.provinceList,
            cityList: state.locationDataReducer.cityList,
            //filterData: state.service.searchServiceFilters,
            fieldList: state.UserReducer.pageFieldList,
            usersList: state.UserReducer.userList,
            mainPGList: state.ProductReducer.productMainGroupList,
            pgList: state.ProductReducer.productGroupList,
            filterData: state.service.reportGeneratorFilters
        }
    });
    const extAttrList = Array.isArray(serviceExtraAttrSettings) ? serviceExtraAttrSettings?.filter(s => s.SettingName.includes("Services_ExtAttr")) : [];
    const cmbAttrList = Array.isArray(serviceExtraAttrSettings) ? serviceExtraAttrSettings?.filter(s => s.SettingName.includes("Services_ComboBoxExtAttr")) : [];
    const chkAttrList = Array.isArray(serviceExtraAttrSettings) ? serviceExtraAttrSettings?.filter(s => s.SettingName.includes("Services_CheckBoxExtAttr")) : [];
    const [selectedColumns, setSelectedColumns] = useState([{ colName: "RowNumber", colTitle: "ردیف", colNameInDB: "" }]);
    const { extAttrSettings } = useSelector(state => { return { extAttrSettings: state.SystemSettingsReducer.serviceExtraAttrSettings } });
    const extAttrSettingsTitles = Array.isArray(extAttrSettings) ? extAttrSettings.filter(e => e.SettingName.includes("_Title")) : [];
    const [dateFilters, setDateFilters] = useState({
        FirstContactDate: null,// filterData?.FirstContactDate,
        ContactDateTo: null,// filterData?.ContactDateTo,
        ServiceDeadline: null,// filterData?.ServiceDeadline,
        ServiceDeadlineTo: null,// filterData?.ServiceDeadlineTo
    });

    const pgType = Array.isArray(systemSettings ?? "") && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
        Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;
    const reportColumns = [
        { ColumnTitle: "نوع خروجی", ColumnNameInDB: "CASE WHEN DeliveryDate IS NOT NULL THEN N'تحویل' WHEN SendDate IS NOT NULL THEN N'ارسال' ELSE N'' END AS ProductExitType" },
        { ColumnTitle: "تاریخ تحویل", ColumnNameInDB: "DeliveryDate" },
        { ColumnTitle: "سریال محصول", ColumnNameInDB: "ProductSerial" },
        { ColumnTitle: "تاریخ پذیرش", ColumnNameInDB: "FirstContactDate" },
        { ColumnTitle: "نام/نوع محصول", ColumnNameInDB: "ProductName" },
        { ColumnTitle: "مدل محصول", ColumnNameInDB: "ProductModel" },
        { ColumnTitle: "کد مشتری", ColumnNameInDB: "CustomerCode" },
        { ColumnTitle: "نام مشتری", ColumnNameInDB: "CustomerName" },
        { ColumnTitle: "تلفن مشتری", ColumnNameInDB: "CustomerPhone" },
        { ColumnTitle: "همراه مشتری", ColumnNameInDB: "CustomerMobile" },
        { ColumnTitle: "نشانی مشتری", ColumnNameInDB: "ServiceAddress" },
        { ColumnTitle: "نام تکنسین", ColumnNameInDB: "RefStaffName" },
        { ColumnTitle: "کد تکنسین", ColumnNameInDB: "RefStaffCode" },
        { ColumnTitle: "وضعیت سرویس", ColumnNameInDB: "Status" },
        { ColumnTitle: "نوع سرویس", ColumnNameInDB: "CASE WHEN ServiceType = 'Install' THEN N'نصب' ELSE N'تعمیر' END AS PServiceType" },
        { ColumnTitle: "شماره سرویس", ColumnNameInDB: "InvoiceNumber" },
        { ColumnTitle: "شماره قبض", ColumnNameInDB: "MainCoInvoiceNumber" },
        { ColumnTitle: "نوع پذیرش", ColumnNameInDB: "CASE WHEN SupportID = 1 THEN N'گارانتی' ELSE N'آزاد' END AS ReceptionType" },
        { ColumnTitle: "تاریخ ثبت", ColumnNameInDB: "CreationDate" },
        { ColumnTitle: "تاریخ بازدید بعدی", ColumnNameInDB: "DurationalDeadline" },
        { ColumnTitle: "قابل پرداخت", ColumnNameInDB: "AmountCustomerShouldPay", ColumnType: "currency" },
        { ColumnTitle: "مالیات", ColumnNameInDB: "TaxAmount", ColumnType: "currency" },
        { ColumnTitle: "پایان گارانتی", ColumnNameInDB: "GaranteeEndDate" },
        { ColumnTitle: "مانده گارانتی به روز", ColumnNameInDB: "DATEDIFF(DD, GETDATE(), GaranteeEndDate) AS RemainedGuaranteeDays" },
        { ColumnTitle: "اظهارات مشتری", ColumnNameInDB: "Attr7" },
        { ColumnTitle: "توضیحات", ColumnNameInDB: "Description" },
        { ColumnTitle: "تاریخ بایگانی", ColumnNameInDB: "ArchiveDate" },
        { ColumnTitle: "تاریخ ارسال", ColumnNameInDB: "SendDate" },
        { ColumnTitle: "نوع ارسال", ColumnNameInDB: "SendType" },
        { ColumnTitle: "شماره مرسوله", ColumnNameInDB: "SendNo" },
        { ColumnTitle: "شماره جعبه", ColumnNameInDB: "PackageNo" },
        { ColumnTitle: "تحویل دهنده", ColumnNameInDB: "DeliverByName" },
        { ColumnTitle: "ارسال کننده", ColumnNameInDB: "SendByName" },
        { ColumnTitle: "تاریخ ارجاع به تکنسین", ColumnNameInDB: "StaffSendDate" },
        { ColumnTitle: "کد تکنسین اعزامی", ColumnNameInDB: "SentStaffCode" },
        { ColumnTitle: "نام تکنسین اعزامی", ColumnNameInDB: "SentStaffName" },
        { ColumnTitle: "پیام های داخلی", ColumnNameInDB: "ServiceMessages", ColumnType: "string" },
        { ColumnTitle: "ایرادات فنی", ColumnNameInDB: "ServiceBugs", ColumnType: "string" },
        { ColumnTitle: "تاریخ موعد", ColumnNameInDB: "ServiceDeadline" },
        { ColumnTitle: "مدت انجام کار", ColumnNameInDB: "DATEDIFF(hh,FirstContactDate, LastSuccessReferralDate) AS ServiceDoneTime" },
        { ColumnTitle: "تاریخ اتمام", ColumnNameInDB: "LastSuccessReferralDate" },
        { ColumnTitle: "کد تعرفه", ColumnNameInDB: "DefinedServiceCode" },
        { ColumnTitle: "شرح تعرفه", ColumnNameInDB: "DefinedServiceDesc" },
        { ColumnTitle: "مبلغ تعرفه", ColumnNameInDB: "DefinedServiceCost", ColumnType: "currency" },
        { ColumnTitle: "گارانتی تعرفه", ColumnNameInDB: "DefinedCostIsGuarantee", ColumnType: "boolean" },
        { ColumnTitle: "جمع تعرفه های گارانتی", ColumnNameInDB: "TotalGuaranteeDefinedCost", ColumnType: "currency" },
        { ColumnTitle: "جمع تعرفه های آزاد", ColumnNameInDB: "TotalNonGuaranteeDefinedCost", ColumnType: "currency" },
        { ColumnTitle: "جمع تعرفه ها", ColumnNameInDB: "TotalGuaranteeDefinedCost + TotalNonGuaranteeDefinedCost AS TotalDefinedCost", ColumnType: "currency" },
        { ColumnTitle: "سهم تعرفه تکنسین", ColumnNameInDB: "DefinedServiceStaffShare", ColumnType: "currency" },
        { ColumnTitle: "ایاب و ذهاب", ColumnNameInDB: "ReferralCost", ColumnType: "currency" },
        { ColumnTitle: "جمع ایاب و ذهاب گارانتی", ColumnNameInDB: "TotalGuaranteeReferralCost", ColumnType: "currency" },
        { ColumnTitle: "جمع ایاب و ذهاب آزاد", ColumnNameInDB: "TotalNonGuaranteeReferralCost", ColumnType: "currency" },
        { ColumnTitle: "جمع ایاب و ذهاب", ColumnNameInDB: "TotalGuaranteeReferralCost + TotalNonGuaranteeReferralCost AS TotalReferralCost", ColumnType: "currency" },
        { ColumnTitle: "تاریخ مراجعه", ColumnNameInDB: "ReferralDate" },
        { ColumnTitle: "سهم مراجعه تکنسین", ColumnNameInDB: "ReferralStaffShare", ColumnType: "currency" },
        { ColumnTitle: "سایر خدمات", ColumnNameInDB: "ExtraServiceDesc" },
        { ColumnTitle: "بهای سایر خدمات", ColumnNameInDB: "ExtraServiceCost", ColumnType: "currency" },
        { ColumnTitle: "گارانتی سایر خدمات", ColumnNameInDB: "ExtraServiceIsGuarantee", ColumnType: "boolean" },
        { ColumnTitle: "جمع سایر خدمات گارانتی", ColumnNameInDB: "TotalExtraServiceGuaranteeCost", ColumnType: "currency" },
        { ColumnTitle: "جمع سایر خدمات آزاد", ColumnNameInDB: "TotalExtraServiceNonGuaranteeCost", ColumnType: "currency" },
        { ColumnTitle: "جمع سایر خدمات", ColumnNameInDB: "TotalExtraServiceNonGuaranteeCost + TotalExtraServiceGuaranteeCost AS TotalExtraServiceCost", ColumnType: "currency" },
        { ColumnTitle: "سهم سایر خدمات نکنسین", ColumnNameInDB: "ExtraServiceStaffShare", ColumnType: "currency" },
        { ColumnTitle: "نام قطعه مصرفی", ColumnNameInDB: "UsedPartName" },
        { ColumnTitle: "مدل قطعه مصرفی", ColumnNameInDB: "UsedPartModel" },
        { ColumnTitle: "بهای کل قطعه مصرفی", ColumnNameInDB: "UsedPartPrice", ColumnType: "currency" },
        { ColumnTitle: "تعداد قطعه مصرفی", ColumnNameInDB: "UsedPartCount" },
        { ColumnTitle: "بهای واحد قطعه مصرفی", ColumnNameInDB: "UsedPartUnitPrice", ColumnType: "currency" },
        { ColumnTitle: "گارانتی قطعه مصرفی", ColumnNameInDB: "UsedPartIsGuarantee" },
        { ColumnTitle: "بهای قطعات مصرفی گارانتی", ColumnNameInDB: "UsedPartsTotalGuaranteePrice", ColumnType: "currency" },
        { ColumnTitle: "بهای قطعات مصرفی آزاد", ColumnNameInDB: "UsedPartsTotalNonGuaranteePrice", ColumnType: "currency" },
        { ColumnTitle: "بهای خرید قطعات مصرفی", ColumnNameInDB: "UsedPartsPurchasePrice", ColumnType: "currency" },
        { ColumnTitle: "بهای  قطعات مصرفی", ColumnNameInDB: "UsedPartsTotalGuaranteePrice + UsedPartsTotalNonGuaranteePrice AS TotalUsedPartsCost", ColumnType: "currency" },
        { ColumnTitle: "تخفیف", ColumnNameInDB: "Discount", ColumnType: "currency" },
        { ColumnTitle: "سهم تکنسین", ColumnNameInDB: "StaffTotalShare", ColumnType: "currency" },
        { ColumnTitle: "پرداختی به تکنسین", ColumnNameInDB: "StaffTotalPayments", ColumnType: "currency" },
        { ColumnTitle: "کد نماینده", ColumnNameInDB: "AgentCode" },
        { ColumnTitle: "نام نماینده", ColumnNameInDB: "AgentName" },
        { ColumnTitle: "همراه نماینده", ColumnNameInDB: "AgentMobile" },
        { ColumnTitle: "سریال تعویضی", ColumnNameInDB: "NewProductSerial" },
        { ColumnTitle: "خارج از گارانتی", ColumnNameInDB: "IsGuaranteeCanceled", ColumnType: "boolean" },
        { ColumnTitle: "کاربر پذیرش", ColumnNameInDB: "CreateByName" },
        { ColumnTitle: "استان", ColumnNameInDB: "ProvinceName" },
        { ColumnTitle: "شهر", ColumnNameInDB: "CityName" },
        { ColumnTitle: "منطقه", ColumnNameInDB: "ZoneName" },
        { ColumnTitle: "گروه اصلی محصول", ColumnNameInDB: "MainGroupName" },
        { ColumnTitle: "گروه فرعی محصول", ColumnNameInDB: "GroupName" },
        { ColumnTitle: "مارک محصول", ColumnNameInDB: "ProductHolderName" },
        { ColumnTitle: "دوره مالی", ColumnNameInDB: "DurationName" },
        { ColumnTitle: "شماره گارانتی", ColumnNameInDB: "GaranteeCardNo" },
        { ColumnTitle: "تاریخ آغاز گارانتی", ColumnNameInDB: "GaranteeStartDate" },
        { ColumnTitle: "تاریخ پایان گارانتی", ColumnNameInDB: "GaranteeEndDate" },
        { ColumnTitle: "کد ملی نماینده", ColumnNameInDB: "AgentNationalCode" },
        { ColumnTitle: "کد ملی مشتری", ColumnNameInDB: "CustomerNationalCode" },
        { ColumnTitle: "نام فروشگاه", ColumnNameInDB: "ShopName" },
        { ColumnTitle: "حساب مقصد", ColumnNameInDB: "TargetAccountName" },
        { ColumnTitle: "شرح دستی سند", ColumnNameInDB: "ManualDocDesc" },
        { ColumnTitle: "حساب شرکت مادر", ColumnNameInDB: "AmountMainCompanyPays" },
        { ColumnTitle: "پرداختی مشتری", ColumnNameInDB: "CustomerPayment" },
        { ColumnTitle: "پذیرش در نمایندگی", ColumnNameInDB: "ReceptionInAgent" },
        { ColumnTitle: "مرحله سرویس", ColumnNameInDB: "StageName" },
        { ColumnTitle: "تاریخ ارجاع به کاربر", ColumnNameInDB: "ReferDate" },
        { ColumnTitle: "کاربر کارتابل", ColumnNameInDB: "ReferUser" },
        {ColumnTitle:"شرح رسیدگی",ColumnNameInDB:"ConsiderDescription"}
    ]
    if (Array.isArray(extAttrSettingsTitles)) {
        extAttrSettingsTitles.filter(s => !s.SettingName.includes("CheckBoxExtAttr"))
            .forEach(ex =>
                reportColumns.push({ ColumnTitle: ex.SettingValue, ColumnNameInDB: ex.SettingName.replace("Services_", "").replace("_Title", "") }));
    }
    const reportSettingCols = [
        { colTitle: "انتخاب", colName: "select", colType: "boolean", editable: true, onChange: selectRow, /*selectAll: selectAllRows,*/ showInMobile: true },
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "ColumnTitle", colTitle: "عنوان ستون", showInMobile: true },
        { colTitle: "", colName: "ColumnNameInDB", style: { display: "none" }, headerStyle: { display: "none" } }
    ]
    const popReportTemplates = (
        <Popover style={{ fontFamily: "Vazir", maxWidth: "350px", fontSize: "12px", minWidth: "350px" }}>
            <Popover.Title className="headerStyle">
                قالب های گزارش
            </Popover.Title>
            <Popover.Content className="bodyStyle">
                <Table className="fixedHeightTable">
                    <thead>
                        <tr>
                            <th>نام قالب گزارش</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {reportTemplates?.Data &&
                            (reportTemplates.Data.map((rt, i) => <tr key={i}>
                                <td>{rt.ReportTitle}</td>
                                <td>
                                    <Trash color="red" size={18} className="rowBtn" onClick={() =>
                                        dispatch(setDialog({
                                            status: 'show',
                                            arrayBtn: ['yes', 'no'],
                                            dialogTitle: 'حذف قالب گزارش',
                                            dialogText: 'آیا از حذف مطمئن هستید؟',
                                            okOperation: () => deleteTemplate(rt.ID)
                                        }))
                                    } />&nbsp;
                                    <Download color="blue" size={18} className="rowBtn" onClick={() => loadTemplateData(rt)} />
                                </td>
                            </tr>))
                        }
                    </tbody>
                </Table>
                <FormGroup>
                    <Form.Control placeholder="نام قالب گزارش" ref={inputReportTitle} />
                    <Button className="btn-input-tiny" variant="info" style={{ top: 2, left: 2 }} onClick={saveTemplate}><Check2 size={23} /></Button>
                </FormGroup>
            </Popover.Content>
        </Popover>
    )
    function selectRow(row) {
        let colNameInDB = row.ColumnNameInDB;
        let colName = colNameInDB;
        if (colNameInDB?.includes(" AS ")) {
            colName = row.ColumnNameInDB.split("AS ")[1];
        }
        if (colNameInDB == "FirstContactDate" ||
            colNameInDB == "DeliveryDate" ||
            colNameInDB == "CreationDate" ||
            colNameInDB == "GaranteeEndDate" ||
            colNameInDB == "DurationalDeadline" ||
            colNameInDB == "ArchiveDate" ||
            colNameInDB == "SendDate" ||
            colNameInDB == "StaffSendDate" ||
            colNameInDB == "ServiceDeadline" ||
            colNameInDB == "LastSuccessReferralDate" ||
            colNameInDB == "ReferralDate" ||
            colNameInDB == "GaranteeStartDate" ||
            colNameInDB == "ReferDate" ||
            colNameInDB == "DeliveryDate"
        ) {
            colName = "P" + colName;
        }
        if (row.e.target.checked) {
            if (!selectedColumns.some(r => r.colName === colNameInDB)) {

                // if (colNameInDB.includes(" AS ")) {
                //     colNameInDB = row.ColumnNameInDB.split(" AS")[0];//colNameInDB.substring(colNameInDB.indexOf("AS ") + 3, colNameInDB.length);
                // }

                setSelectedColumns([...selectedColumns,
                {
                    colType: row.ColumnType,
                    maxTextLength: row.ColumnType === "string" ? 50 : undefined,
                    hasTooltip: row.ColumnType === "string",
                    colTitle: row.ColumnTitle,
                    colNameInDB: colNameInDB,
                    colName: colName
                }]);
            }
        }
        else {
            setSelectedColumns([...selectedColumns.filter(r => r.colNameInDB !== colNameInDB)]);
        }

    }
    function selectAllRows(e) {
        (async () => setReportResult({}))().then(() => {
            const selectedCols = [{ colName: "RowNumber", colTitle: "ردیف", colNameInDB: "" }];
            const table = e.target.closest("table");
            table.style.display = "none";
            for (let i = 1; i < table.rows.length; i++) {
                const row = table.rows[i];
                const column = {};
                for (let j = 0; j < row.cells.length; j++) {
                    if (row.cells[j]?.getAttribute("colname") === "select") {
                        const firstChild = row.cells[j].firstChild;
                        if (firstChild?.type === "checkbox") {
                            firstChild.checked = e.target.checked;
                        }
                    }
                    if (row.cells[j]?.getAttribute("colname") === "ColumnNameInDB") {
                        if (e.target.checked) {
                            const nameInDB = row.cells[j].firstChild.nodeValue;
                            if (nameInDB?.length > 0) {
                                column.colNameInDB = nameInDB;
                                if (nameInDB.includes(" AS ")) {
                                    column.colName = nameInDB.substring(nameInDB.indexOf("AS ") + 3, nameInDB.length);
                                }
                                else {
                                    column.colName = nameInDB;
                                }
                                if (column.colName == "FirstContactDate" ||
                                    column.colName == "DeliveryDate" ||
                                    column.colName == "CreationDate" ||
                                    column.colName == "GaranteeEndDate" ||
                                    column.colName == "DurationalDeadline" ||
                                    column.colName == "ArchiveDate" ||
                                    column.colName == "SendDate" ||
                                    column.colName == "StaffSendDate" ||
                                    column.colName == "ServiceDeadline" ||
                                    column.colName == "LastSuccessReferralDate" ||
                                    column.colName == "ReferralDate" ||
                                    column.colName == "GaranteeStartDate" ||
                                    column.colName == "ReferDate" ||
                                    column.colName == "DeliveryDate"
                                ) {
                                    column.colName = "P" + column.colName;
                                }
                            }
                        }
                    }
                    if (row.cells[j]?.getAttribute("colname") === "ColumnTitle") {
                        if (e.target.checked) {
                            const colTitle = row.cells[j].firstChild.nodeValue;
                            column.colTitle = colTitle;
                        }
                    }
                }
                if (column.colNameInDB?.length > 0) {
                    selectedCols.push(column);
                }
            }
            setSelectedColumns([...selectedCols]);
            table.style.display = "table";
        });
    }
    function search(data) {
        if (selectedStaff?.ID) {
            data.SentStaffID = selectedStaff.ID;
            // data.SentStaffName = selectedStaff.LastName;
        }
        if (selectedRefStaff?.ID) {
            data.RefStaffID = selectedRefStaff.ID;
        }
        if (document.getElementsByName("deadlineFrom")[0]?.value !== "") {
            data.ServiceDeadlineFrom = dateFilters.ServiceDeadline;
        }
        if (document.getElementsByName("deadlineTo")[0]?.value !== "") {
            data.ServiceDeadlineTo = dateFilters.ServiceDeadlineTo;
        }
        if (document.getElementsByName("dateFrom")[0]?.value !== "") {
            data.FirstContactDateFrom = dateFilters.FirstContactDate;
        }
        if (document.getElementsByName("dateTo")[0]?.value !== "") {
            data.FirstContactDateTo = dateFilters.ContactDateTo;
        }
        if (document.getElementsByName("lastRefDateFrom")[0]?.value !== "") {
            data.LastSuccessReferralDateFrom = dateFilters.LastRefDateFrom;
        }
        if (document.getElementsByName("lastRefDateTo")[0]?.value !== "") {
            data.LastSuccessReferralDateTo = dateFilters.LastRefDateTo;
        }
        if (document.getElementsByName("archiveDateFrom")[0]?.value !== "") {
            data.ArchiveDateFrom = dateFilters.ArchiveDateFrom;
        }
        if (document.getElementsByName("archiveDateTo")[0]?.value !== "") {
            data.ArchiveDateTo = dateFilters.ArchiveDateTo;
        }
        if (document.getElementsByName("staffSendDateFrom")[0]?.value !== "") {
            data.StaffSendDateFrom = dateFilters.StaffSendDateFrom;
        }
        if (document.getElementsByName("staffSendDateTo")[0]?.value !== "") {
            data.StaffSendDateTo = dateFilters.StaffSendDateTo;
        }
        if (document.getElementsByName("sendDateFrom")[0]?.value !== "") {
            data.SendDateFrom = dateFilters.SendDateFrom;
        }
        if (document.getElementsByName("sendDateTo")[0]?.value !== "") {
            data.SendDateTo = dateFilters.SendDateTo;
        }
        if (document.getElementsByName("deliveryDateFrom")[0]?.value !== "") {
            data.DeliveryDateFrom = dateFilters.DeliveryDateFrom;
        }
        if (document.getElementsByName("deliveryDateTo")[0]?.value !== "") {
            data.DeliveryDateTo = dateFilters.DeliveryDateTo;
        }
        if (document.getElementsByName("durationalDeadlineFrom")[0]?.value !== "") {
            data.DurationalDeadlineFrom = dateFilters.DurationalDeadlineFrom;
        }
        if (document.getElementsByName("durationalDeadlineTo")[0]?.value !== "") {
            data.DurationalDeadlineTo = dateFilters.DurationalDeadlineTo;
        }
        if (document.getElementsByName("creationDateFrom")[0]?.value !== "") {
            data.CreationDateFrom = dateFilters.CreationDateFrom;
        }
        if (document.getElementsByName("creationDateTo")[0]?.value !== "") {
            data.CreationDateTo = dateFilters.CreationDateTo;
        }

        if (!checkFieldPermission("IsArchive", "Read")) {
            data.IsArchive = false;
        }

        data.StatusIDList = selectedStatusList.current;
        data.StageIDList = selectedPhaseList.current;
        const filters = [];
        const inputFilterTypes = document.querySelectorAll("input[filtertype]");
        Object.keys(data).forEach(d => {
            const filter = { Value: data[d], Name: d };
            for (let i = 0; i < inputFilterTypes.length; i++) {
                const input = inputFilterTypes[i];
                if (input.name === d) {
                    filter.FilterType = input.getAttribute("filtertype");
                }
            }
            filters.push(filter);
        });
        const reportData = { FilterData: filters, Take: 500, Skip: 0 };
        setReportResult("PENDING");
        if (selectOrderBy.current.value && selectOrderBy.current.value !== "") {
            reportData.OrderBy = selectOrderBy.current.value;
        }
        reportData.ColumnNames = selectedColumns.filter(c => c.colName !== "RowNumber").map(s => s.colNameInDB);
        // getReportGeneratorReportData(reportData, setReportResult);
        dispatch(getReportGeneratorReportData(reportData));
    }
    function toExcel() {
        const url = "api/ServiceReportsAPI/GetReportGeneratorReport";
        const searchArgs = { ...filterData, Skip: 0, Take: 0 };
        setPending(true);
        exportToExcel("ReportGenrator", searchArgs, url, "post", selectedColumns, () => setPending(false));
    }
    function printReport(e) {
        setModalPrintData({ show: true, designMode: e.ctrlKey, reportName: "ServiceReportGenerator" });
        // const companyInfo = JSON.parse(localStorage.getItem("Company"));
        // const divFilters = document.getElementById("divFilters");
        // var divToPrint = tblResult.current;
        // var htmlToPrint = '' +
        //     '<style type="text/css">' +
        //     'body{direction:rtl; font-family:Vazir; direction:rtl; font-size:12px}' +
        //     'table{margin:auto; width:100%}' +
        //     'table th, table td {' +
        //     'font-family:Vazir !important;' +
        //     'font-size:12px;' +
        //     'border:1px solid #000;' +
        //     'text-align:center;' +
        //     'padding:0.5em;' +
        //     '}' +
        //     '#tableRowSearch{display:none !important}' +
        //     '</style>';
        // const filters = divFilters.querySelectorAll(".search-input");
        // let filtersHtml = "";
        // for (let i = 0; i < filters.length; i++) {
        //     const fg = filters[i];
        //     if (!fg.value || fg.value === "") {
        //         continue;
        //     }
        //     if (fg.tagName === "SELECT" && fg.length > 0 && fg.name !== "") {
        //         filtersHtml += "<div>" + fg[0].text.replace("را انتخاب کنید", "") + ":" + fg.value + "</div>";
        //     }
        //     else {
        //         filtersHtml += "<div>" + fg.placeholder + ":" + fg.value + "</div>";
        //     }

        // }

        // //htmlToPrint+=divfilters.outerHTML;
        // htmlToPrint += `<div style='text-align:center; font-size:11px'>تاریخ گزارش:${momentJalaali().format("jYYYY/jMM/jDD")}</div>`;
        // if (filtersHtml?.length > 1) {
        //     htmlToPrint += "<div style='display:flex; justify-content:space-between; border:1px solid gray; margin:10px;padding:5px;border-radius:4px'>" + filtersHtml + "</div>";
        // }
        // htmlToPrint += divToPrint.outerHTML;
        // htmlToPrint += `<div style='text-align:center; font-size:11px'>${companyInfo?.CompanyName}</div><div style='text-align:center; font-size:11px'>${companyInfo?.CompanyAddress}</div><div style='text-align:center; font-size:11px'>${companyInfo?.Phone}</div>`
        // const newWin = window.open("");
        // newWin.document.write(htmlToPrint);
        // newWin.print();
        //newWin.close();

    }
    function onServiceStatusChanged(item) {
        if (!selectedStatusList.current) {
            selectedStatusList.current = [];
        }
        const splited = item.value.split(",");
        if (item.checked) {
            if (!selectedStatusList.current.includes(splited)) {

                selectedStatusList.current.push(...splited);
            }
        }
        else {
            selectedStatusList.current = selectedStatusList.current.filter(a => !splited.includes(a));
        }
    }
    function onServicePhaseChanged(item) {
        if (!selectedPhaseList.current) {
            selectedPhaseList.current = [];
        }
        const splited = item.value.split(",");
        if (item.checked) {
            if (!selectedPhaseList.current.includes(splited)) {

                selectedPhaseList.current.push(...splited);
            }
        }
        else {
            selectedPhaseList.current = selectedPhaseList.current.filter(a => !splited.includes(a));
        }
    }
    function checkFieldPermission(fieldName, actionType) {
        let result = true;
        let field = fieldList?.find(f => f.PageName === "SearchService" && f.Name === fieldName);
        if (actionType === "Read" && field) {
            result = field.IsRead === true;
        }
        if (actionType === "Edit" && field) {
            result = field.IsUpdate === false;
        }
        return result;
    }
    function loadCityList(provinceID) {
        dispatch(getCityList(provinceID));
    }
    function showModalStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            setStaffData(data);
        }
        setPopStaff({ show: true, onSelect: onSelect });
    }
    function showModalRefStaff(e) {
        if (e.key) {
            if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
                return;
            }
            e.preventDefault();
        }
        const onSelect = (data) => {
            setRefStaffData(data);
        }
        setPopStaff({ show: true, onSelect: onSelect });
    }
    function saveTemplate() {
        if (pending) {
            return;
        }
        if (selectedColumns.length === 1) {
            setErrorDialog(dispatch, "ستونی برای خروجی انتخاب نشده است.", "ذخیره قالب گزارش");
            return;
        }
        if (inputReportTitle.current.value === '') {
            setErrorDialog(dispatch, "عنوانی برای گزارش انتخاب نشده است.", "ذخیره قالب گزارش");
            return;
        }
        setPending(true);
        const columns = selectedColumns.filter(r => r.colName !== "RowNumber").map(c => c.colNameInDB + "|" + c.colTitle + "|" + (c.colType ?? "-"));
        const outputColumnsInfo = columns.join("&");
        const onSave = (res) => {
            setPending(false);
            if (res?.Data) {
                setErrorDialog(dispatch, "success", "ذخیره قالب گزارش");
                const onGet = (res) => {
                    if (res.Data) {
                        (async () => setReportTemplates(res))().then(() => setReportTilesAlignment());
                    }
                }
                getReportGeneratorTemplates(onGet);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "ذخیره قالب گزارش");
            }
        }
        const data = { ReportTitle: inputReportTitle.current.value, OutputColumnsInfo: outputColumnsInfo }
        saveReportGeneratorTemplate(data, onSave);
    }
    function loadTemplateData(template) {
        setReportResult({ Data: [] });
        const columns = template.OutputColumns.split("&");
        const selectedCols = columns.map(c => {
            const splitted = c.split("|");
            const colNameInDB = splitted[0];
            let colName = colNameInDB;
            if (colName.includes(" AS ")) {
                colName = colNameInDB.split("AS ")[1];
            }
            if (colName == "FirstContactDate" ||
                colName == "DeliveryDate" ||
                colName == "CreationDate" ||
                colName == "GaranteeEndDate" ||
                colName == "DurationalDeadline" ||
                colName == "ArchiveDate" ||
                colName == "SendDate" ||
                colName == "StaffSendDate" ||
                colName == "ServiceDeadline" ||
                colName == "LastSuccessReferralDate" ||
                colName == "ReferralDate" ||
                colName == "GaranteeStartDate" ||
                colName == "ReferDate" ||
                colName == "DeliveryDate"
            ) {
                colName = "P" + colName;
            }
            return ({
                maxTextLength: 50,
                hasTooltip: true,
                colNameInDB: colNameInDB,
                colTitle: splitted[1],
                colType: splitted[2] === "-" ? undefined : splitted[1],
                colName: colName
            });
        });
        const table = tblReportCols.current;
        table.style.display = "none";
        for (let i = 1; i < table.rows.length; i++) {
            const row = table.rows[i];
            let checkbox = null;
            for (let j = 0; j < row.cells.length; j++) {
                if (row.cells[j]?.getAttribute("colname") === "select") {
                    const firstChild = row.cells[j].firstChild;
                    if (firstChild?.type === "checkbox") {
                        checkbox = firstChild;
                    }
                }
                if (row.cells[j]?.getAttribute("colname") === "ColumnNameInDB") {
                    const nameInDB = row.cells[j].firstChild.nodeValue;
                    if (selectedCols.some(s => s.colNameInDB === nameInDB) && checkbox) {
                        checkbox.checked = true;
                    }

                }
            }
        }
        table.style.display = "table";
        setSelectedColumns([{ colName: "RowNumber", colTitle: "ردیف" }, ...selectedCols]);


    }
    function deleteTemplate(id) {
        const onDelete = (res) => {
            if (res.Data) {
                const onGet = (res) => {
                    if (res.Data) {
                        (async () => setReportTemplates(res))().then(() => setReportTilesAlignment());
                    }
                }
                getReportGeneratorTemplates(onGet);
            }
            else if (res.Error) {
                setErrorDialog(dispatch, res.Error, "حذف قالب گزارش");
            }
        }
        deleteReportGeneratorTemplate(id, onDelete);
    }
    function setReportTilesAlignment(b) {
        const el = divReportTiles.current;
        reportTilesArray.current = [];
        setShowMenuButton(false);
        if (el) {
            const maxWidth = el.clientWidth - 150;
            const buttons = el.querySelectorAll(".btn-outline-secondary");
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].style.display = "unset";
            }
            let sumWidth = 0;
            for (let i = 0; i < buttons.length; i++) {
                const currentBtnWidth = buttons[i].offsetWidth;
                sumWidth += currentBtnWidth;
                const keyName = buttons[i].getAttribute("keyname");
                if (sumWidth >= maxWidth || currentBtnWidth === 0) {
                    buttons[i].style.display = "none";
                    if (keyName) {
                        reportTilesArray.current.push(keyName);
                    }
                }
            }
            if (reportTilesArray.current?.length > 0) {
                setShowMenuButton(true);
            }
        }
    }
    function loadProductGroups(e) {
        const mgID = e.target.value;
        dispatch(getProductGroups(mgID));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        document.title = "بی همتا-خدمات";
        dispatch(getPageFieldList("SearchService"));
        dispatch(getSystemSettings(settingNames));
        dispatch(getAllProvinces());
        dispatch(getExtAttrSettings());
        dispatch(getServiceStatusList());
        dispatch(getStageList("service", setStageList));
        setProductHolders("PENDING");
        getAllGuaranteeHolders("", setProductHolders);
        getAllProductTypes(setProductTypes);
        dispatch(getExtAttrSettingsForSearch());
        dispatch(searchProductBug({ Take: 1000 }));
        dispatch(getAllProductMainGroups());
        dispatch(getUserList(''));
        const onGetTemplates = (res) => {
            if (res.Data) {
                (async () => setReportTemplates(res))().then(() => {
                    setReportTilesAlignment();
                    window.addEventListener("resize", setReportTilesAlignment);
                })
            }
        }
        getReportGeneratorTemplates(onGetTemplates);
        getBaseInfoList(InfoTypes.ServiceConsiderDesc, setConsiderDescList);
        return () => {
            window.removeEventListener("resize", setReportTilesAlignment);
        }
    }, []);
    return (
        <div className="container-fluid mt-1">
            <br />
            <ModalPrintViewer
                modalData={modalPrintData}
                setModalData={setModalPrintData}
                dataUrl="api/ServiceReportsAPI/GetReportGeneratorReport"
                fetchBody={{ ...filterData, Take: 0, Skip: 0 }} />
            <Card>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faTable} size="lg" />&nbsp;
                    گزارش ساز سرویس ها
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <Row style={{ margin: 0 }}>
                        <Col md={9}>
                            <form onSubmit={handleSubmit(search)} ref={frmFilters}>
                                <Row id="divFilters" className="rowBorder" >
                                    <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />
                                    <Col md={2} className="form-group" >
                                        <select className='search-input' name="ServiceType" ref={register({})} >
                                            <option value="">انتخاب نوع سرویس</option>
                                            <option value="repair">تعمیر</option>
                                            <option value="install">نصب</option>
                                        </select>
                                    </Col>
                                    <Col md={2} className="form-group" >
                                        <select className='search-input' name="ReceptionInAgent" ref={register({})}>
                                            <option value="">انتخاب نوع پذیرش</option>
                                            <option value={false}>پذیرش در دفتر مرکزی</option>
                                            <option value={true}>پذیرش در نمایندگی</option>
                                        </select>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='َشماره سرویس' type='number' lang='en' className='search-input' min={0} name="InvoiceNumber" ref={register({})}></input>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='نام نمایندگی' className='search-input' filtertype="Contains" min={0} name="AgencyName" ref={register({})}></input>
                                    </Col>
                                    {pgType === 0 ?
                                        <Fragment>
                                            <Col md={2} className="form-group">
                                                {holders === "PENDING" &&
                                                    <div className='search-input' style={{ textAlign: "center" }}>
                                                        <Loader type="BallTriangle" width={25} height={25} color="bb1370" />
                                                    </div>
                                                }
                                                {Array.isArray(holders) &&
                                                    <select className="search-input scThin" name="ProductHolderName" ref={register({})}>
                                                        <option value="">مارک محصول را انتخاب کنید</option>
                                                        {holders.map((item, i) => <option value={item.HolderName} key={i}>{item.HolderName}</option>)}
                                                    </select>
                                                }
                                            </Col>
                                            <Col md={2} className="form-group">
                                                {productTypes === "PENDING" &&
                                                    <div className='search-input' style={{ textAlign: "center" }}>
                                                        <Loader type="BallTriangle" width={25} height={25} color="bb1370" />
                                                    </div>
                                                }
                                                {Array.isArray(productTypes) &&
                                                    <select className="search-input scThin" name="ProductName" ref={register({})}>
                                                        <option value="">نوع محصول را انتخاب کنید</option>
                                                        {productTypes.map((item, i) => <option value={item.Name} key={i}>{item.Name}</option>)}
                                                    </select>
                                                }
                                            </Col>
                                        </Fragment> :
                                        <Fragment>
                                            <Col md={2} className='form-group'>
                                                {mainPGList === "PENDING" &&
                                                    <div className='search-input' style={{ textAlign: "center" }}>
                                                        <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;در حال بارگذاری فهرست
                                                    </div>
                                                }
                                                {Array.isArray(mainPGList) &&
                                                    <select className='search-input' ref={register({})} onChange={loadProductGroups}>
                                                        <option value="">گروه اصلی کالا را انتخاب کنید</option>
                                                        {mainPGList.map((pg, i) => <option value={pg.MainGroupID} key={i}>{pg.MainGroupName}</option>)}
                                                    </select>
                                                }
                                            </Col>
                                            <Col md={2} className='form-group'>
                                                {pgList === "PENDING" &&
                                                    <div className='search-input' style={{ textAlign: "center" }}>
                                                        <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;در حال بارگذاری فهرست
                                                    </div>
                                                }
                                                {Array.isArray(pgList) &&
                                                    <select className='search-input' name='GroupID' ref={register({})}>
                                                        <option value="">گروه فرعی کالا را انتخاب کنید</option>
                                                        {pgList.map((pg, i) => <option value={pg.GroupID} key={i}>{pg.GroupName}</option>)}
                                                    </select>
                                                }
                                            </Col>
                                            <Col md={2} className='form-group'>
                                                <input placeholder='نام محصول' className='search-input' name="ProductName" ref={register({})} filtertype="Contains"></input>
                                            </Col>
                                        </Fragment>
                                    }
                                    <Col md={2} className='form-group'>
                                        <input placeholder="مدل محصول" className='search-input' name="ProductModel" ref={register({})} filtertype="Contains"></input>
                                    </Col>

                                    <Col md={2} className='form-group'>
                                        <input placeholder='سریال محصول' className='search-input' name="ProductSerial" ref={register({})} filtertype="Contains" style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}></input>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='شماره گارانتی' className='search-input' name="GaranteeCardNo" ref={register({})} filtertype="Contains" style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }}></input>
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ ثبت از' isGregorian={false} timePicker={false} className="search-input" name="creationDateFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, CreationDateFrom: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.CreationDateFrom ? momentJalaali(dateFilters.CreationDateFrom) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ ثبت تا' isGregorian={false} timePicker={false} className="search-input" name="creationDateTo"
                                            onChange={value => setDateFilters({ ...dateFilters, CreationDateTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.CreationDateTo ? momentJalaali(dateFilters.CreationDateTo) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ پذیرش از' isGregorian={false} timePicker={false} className="search-input" name="dateFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, FirstContactDate: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.FirstContactDate ? momentJalaali(dateFilters.FirstContactDate) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ پذیرش تا' isGregorian={false} timePicker={false} className="search-input" name="dateTo"
                                            onChange={value => setDateFilters({ ...dateFilters, ContactDateTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.ContactDateTo ? momentJalaali(dateFilters.ContactDateTo) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ موعد از' isGregorian={false} timePicker={false} className="search-input" name="deadlineFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, ServiceDeadline: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.ServiceDeadline ? momentJalaali(dateFilters.ServiceDeadline) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ موعد تا' isGregorian={false} timePicker={false} className="search-input" name="deadlineTo"
                                            onChange={value => setDateFilters({ ...dateFilters, ServiceDeadlineTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.ServiceDeadlineTo ? momentJalaali(dateFilters.ServiceDeadlineTo) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ بازدید از' isGregorian={false} timePicker={false} className="search-input" name="durationalDeadlineFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, DurationalDeadlineFrom: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.DurationalDeadlineFrom ? momentJalaali(dateFilters.DurationalDeadlineFrom) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ بازدید تا' isGregorian={false} timePicker={false} className="search-input" name="durationalDeadlineTo"
                                            onChange={value => setDateFilters({ ...dateFilters, DurationalDeadlineTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.DurationalDeadlineTo ? momentJalaali(dateFilters.DurationalDeadlineTo) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ اعزام از' isGregorian={false} timePicker={false} className="search-input" name="staffSendDateFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, StaffSendDateFrom: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.StaffSendDateFrom ? momentJalaali(dateFilters.StaffSendDateFrom) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ اعزام تا' isGregorian={false} timePicker={false} className="search-input" name="staffSendDateTo"
                                            onChange={value => setDateFilters({ ...dateFilters, StaffSendDateTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.StaffSendDateTo ? momentJalaali(dateFilters.StaffSendDateTo) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ انجام از' isGregorian={false} timePicker={false} className="search-input" name="lastRefDateFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, LastRefDateFrom: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.LastRefDateFrom ? momentJalaali(dateFilters.LastRefDateFrom) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ انجام تا' isGregorian={false} timePicker={false} className="search-input" name="lastRefDateTo"
                                            onChange={value => setDateFilters({ ...dateFilters, LastRefDateTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.LastRefDateTo ? momentJalaali(dateFilters.LastRefDateTo) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ بایگانی از' isGregorian={false} timePicker={false} className="search-input" name="archiveDateFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, ArchiveDateFrom: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.ArchiveDateFrom ? momentJalaali(dateFilters.ArchiveDateFrom) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ بایگانی تا' isGregorian={false} timePicker={false} className="search-input" name="archiveDateTo"
                                            onChange={value => setDateFilters({ ...dateFilters, ArchiveDateTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.ArchiveDateTo ? momentJalaali(dateFilters.ArchiveDateTo) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ ارسال از' isGregorian={false} timePicker={false} className="search-input" name="sendDateFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, SendDateFrom: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.SendDateFrom ? momentJalaali(dateFilters.SendDateFrom) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ ارسال تا' isGregorian={false} timePicker={false} className="search-input" name="sendDateTo"
                                            onChange={value => setDateFilters({ ...dateFilters, SendDateTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.SendDateTo ? momentJalaali(dateFilters.SendDateTo) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingLeft: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ تحویل از' isGregorian={false} timePicker={false} className="search-input" name="deliveryDateFrom"
                                            onChange={value => setDateFilters({ ...dateFilters, DeliveryDateFrom: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.DeliveryDateFrom ? momentJalaali(dateFilters.DeliveryDateFrom) : null} />
                                    </Col>
                                    <Col md={1} className="form-group" style={{ paddingRight: !isMobile ? "2px" : "0.75rem" }}>
                                        <DatePicker placeholder='تاریخ تحویل تا' isGregorian={false} timePicker={false} className="search-input" name="deliveryDateTo"
                                            onChange={value => setDateFilters({ ...dateFilters, DeliveryDateTo: value.local("en").format("YYYY-MM-DD") })}
                                            value={dateFilters?.DeliveryDateTo ? momentJalaali(dateFilters.DeliveryDateTo) : null} />
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='نام مشتری' type='text' className='search-input' name='CustomerName' ref={register({})}></input>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='تلفن مشتری' className='search-input' type='number' lang='en' name="CustomerPhone" ref={register({})}></input>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='همراه مشتری' className='search-input' type='number' lang='en' name="CustomerMobile" ref={register({})}></input>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='نشانی مشتری' className='search-input' type='text' name="ServiceAddress" ref={register({})} filtertype="Contains"></input>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='اظهارات مشتری' className='search-input' type='text' name="Attr7" ref={register({})} filtertype="Contains"></input>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='توضیحات' className='search-input' type='text' name="Description" ref={register({})} filtertype="Contains"></input>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <select className="search-input scThin" onChange={e => loadCityList(e.target.value)} name="ProvinceID" ref={register({})} >
                                            <option value="">انتخاب استان</option>
                                            {Array.isArray(provinceList) && provinceList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                        </select>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <select className="search-input scThin" name="CityID" ref={register({})}>
                                            <option value="">انتخاب شهر</option>
                                            {Array.isArray(cityList) && cityList.map((item, i) => { return (<option key={i} value={item.Id}>{item.Name}</option>) })}
                                        </select>
                                    </Col>
                                    <Col md={2} className="form-group" >
                                        <select className='search-input' defaultValue={checkFieldPermission("IsArchive", "Read") ? "" : false}
                                            disabled={!checkFieldPermission("IsArchive", "Read")}
                                            name="IsArchive" ref={register({})}>
                                            {checkFieldPermission("IsArchive", "Read") && <option value="">انتخاب وضعیت بایگانی</option>}
                                            {checkFieldPermission("IsArchive", "Read") && <option value={true}>بایگانی شده</option>}
                                            <option value={false}>بایگانی نشده</option>
                                        </select>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        {serviceStatusList === "PENDING" &&
                                            <div className='search-input col-md-3'>
                                                <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                                                <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری </span>
                                            </div>
                                        }
                                        {serviceStatusList && Array.isArray(serviceStatusList) &&
                                            <BihamtaMultiSelect placeholder="انتخاب وضعیت سرویس" dataSource={serviceStatusList} valueItem="ID" displayItem="Status"
                                                className="search-input"
                                                onItemCheckChanged={onServiceStatusChanged} /*defaultCheckedList={filterData?.StatusList}*/ />
                                        }
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <BihamtaMultiSelect placeholder="انتخاب مرحله سرویس" dataSource={stageList} valueItem="ID" displayItem="StageName"
                                            className="search-input"
                                            onItemCheckChanged={onServicePhaseChanged}/* defaultCheckedList={filterData?.StatusPhaseList} */ />
                                    </Col>
                                    {/* <Col md={2} className='form-group'>
                                        <select className='search-input' name='ShowSwapped' ref={register({})}>
                                            <option value={false}>وضعیت جایگزینی</option>
                                            <option value={true}>نمایش سرویس های جایگزین شده</option>
                                        </select>
                                    </Col> */}

                                    <Col md={2} className='form-group'>
                                        <input className="search-input" name="NewProductSerial" ref={register({})} placeholder='سریال جایگزین' filtertype="Contains" />
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='تکنسین اعزامی' className='search-input' readOnly value={selectedStaff?.LastName ?? ""} />
                                        <Button className='btn-input-tiny' style={{ top: "4px" }} onClick={showModalStaff}><List size={17} /></Button>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input placeholder='تکنسین انجام دهنده کار' className='search-input' readOnly value={selectedRefStaff?.LastName ?? ""} />
                                        <Button className='btn-input-tiny' style={{ top: "4px" }} onClick={showModalRefStaff}><List size={17} /></Button>
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        <input className="search-input" name="ReferUser" placeholder="کاربر کارتابل" ref={register({})} />
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        {usersList === "PENDING" &&
                                            <div className='search-input col-md-3'>
                                                <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                                                <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری </span>
                                            </div>
                                        }
                                        {Array.isArray(usersList) &&
                                            <select className="search-input" name="CreateByID" ref={register({})}>
                                                <option value="">ثبت کننده</option>
                                                {usersList.map((item, i) => { return (<option key={i} value={item.ID}>{item.Name}</option>) })}
                                            </select>
                                        }
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        {usersList === "PENDING" &&
                                            <div className='search-input col-md-3'>
                                                <Loader type="BallTriangle" color="#bb1370" height={22} width={22} style={{ display: "inline-block" }} />
                                                <span style={{ color: "#817d7f" }}>&nbsp;در حال بارگذاری </span>
                                            </div>
                                        }
                                        {Array.isArray(usersList) &&
                                            <select className="search-input" name="UpdateByID" ref={register({})}>
                                                <option value="">ویرایش کننده</option>
                                                {usersList.map((item, i) => { return (<option key={i} value={item.ID}>{item.Name}</option>) })}
                                            </select>
                                        }
                                    </Col>
                                    {extAttrList.length > 0 &&
                                        extAttrList.map((item, i) =>
                                            <div key={'Ext' + i} className="form-group col-md-2">
                                                <input className="search-input" placeholder={item.SettingValue} name={item.SettingName.replace("Services_", "").replace("_Title", "")} ref={register({})} filtertype="Contains"
                                                    /*defaultValue={filterData ? (filterData[item.SettingName.replace("Services_", "").replace("_Title", "")] ?? '') : ""} */ />
                                            </div>
                                        )
                                    }
                                    {cmbAttrList.length > 0 && cmbAttrList.filter(s => s.SettingName.includes('_Title')).map((item, i) =>
                                        <div key={i} className="form-group col-md-2">
                                            <select className="search-input scThin" ref={register({})} name={item.SettingName.replace("Services_", "").replace("_Title", "")} /*defaultValue={filterData ? filterData[item.SettingName.replace("Services_", "").replace("_Title", "")] : ''}*/>
                                                <option value=''>انتخاب {item.SettingValue}</option>
                                                {cmbAttrList.find(s => s.SettingName === item.SettingName.replace("_Title", "") + '_Items').SettingValue &&
                                                    cmbAttrList.find(s => s.SettingName === item.SettingName.replace("_Title", "") + '_Items').SettingValue.split("|").map((item, i) => { return (<option key={i} value={item}>{item}</option>) })
                                                }
                                            </select>
                                        </div>
                                    )
                                    }
                                    <Col md={2} className='form-group'>
                                        {considerDescList?.Data ?
                                            <select className="search-input scThin" name="ConsiderDescriptionID" ref={register()}>
                                                <option value="">انتخاب شرح رسیدگی</option>
                                                {considerDescList.Data.map((desc, i) => <option key={i} value={desc.ID}>{desc.InfoName}</option>)}
                                            </select> :
                                            <div className='search-input'>
                                                <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;<span style={{ color: "gray" }}>در حال بارگذاری فهرست </span>
                                            </div>
                                        }
                                    </Col>
                                    <Col md={2} className='form-group'>
                                        {Array.isArray(productBugs ?? "") ?
                                            <select className='search-input scThin' name="ServiceBugs" ref={register()} filtertype="Contains">
                                                <option value="">انتخاب ایراد</option>
                                                {productBugs.map((bug, i) => <option key={i} value={bug.Bug}>{bug.Bug + ` (${bug.Code})`}</option>)}
                                            </select> :
                                            <div className='search-input'>
                                                <Loader type="BallTriangle" width={20} height={20} color="#bb1370" style={{ display: "inline-block" }} />&nbsp;<span style={{ color: "gray" }}>در حال بارگذاری </span>
                                            </div>
                                        }
                                    </Col>
                                    {!isMobile &&
                                        <Col md={2} className='form-group'>
                                            <select className='search-input scThin' ref={selectOrderBy}>
                                                <option value="" style={{ color: "gray" }}>مرتب سازی بر اساس</option>
                                                {selectedColumns.map((sc, i) => {
                                                    if (sc.colNameInDB) {
                                                        let ordrByVal = sc.colNameInDB;
                                                        if (ordrByVal.includes(" AS")) {
                                                            ordrByVal = ordrByVal.split(" AS")[0];
                                                        }
                                                        return (
                                                            <Fragment>
                                                                <option key={i} value={ordrByVal}>{sc.colTitle + "-صعودی"}</option>
                                                                <option key={i} value={ordrByVal + " DESC"}>{sc.colTitle + "-نزولی"}</option>
                                                            </Fragment>
                                                        )
                                                    }
                                                })}
                                            </select>
                                        </Col>
                                    }
                                </Row>

                                <div className='mt-1' style={{ textAlign: "right" }}>
                                    <Button className='group-Btn-large' type="submit" disabled={pending || !(selectedColumns?.length > 1)}><FontAwesomeIcon icon={faTable} size="lg" />&nbsp;نمایش نتایج&nbsp;</Button>
                                    <Button onClick={toExcel} disabled={pending || !(selectedColumns?.length > 1)} className="group-Btn-large  btn-violet"><FileEarmarkExcelFill size={18} />&nbsp;ارسال به اکسل</Button>
                                    <Button onClick={printReport} disabled={pending || !(selectedColumns?.length > 1)} className="group-Btn-large" variant="info"><Printer size={19} />&nbsp;چاپ گزارش</Button>
                                    <OverlayTrigger trigger="click" rootClose overlay={popReportTemplates} placement="left">
                                        <Button variant="secondary" className="group-Btn-large"><ColumnsGap size={18} />&nbsp;قالب های گزارش</Button>
                                    </OverlayTrigger>
                                </div>
                            </form>
                        </Col>
                        <Col md={3}>
                            <BihamtaTable tableRef={tblReportCols} columns={reportSettingCols} dataList={{ Data: reportColumns.sort((c1, c2) => c1.ColumnTitle < c2.ColumnTitle ? -1 : c1.ColumnTitle > c2.ColumnTitle ? 1 : 0) }} maxHeight={500} className="mt-0 mb-0" searchable />
                        </Col>
                    </Row>
                    <ButtonGroup className="mt-2 mb-1" style={{ textAlign: "right", fontSize: "12px", whiteSpace: "nowrap", overflow: "hidden", width: "100%" }} ref={divReportTiles}>

                        {reportTemplates?.Data &&
                            <Fragment>
                                <div style={{ width: "0px", borderRight: "0.5px solid gray" }}></div>
                                {reportTemplates.Data.map((rt, i) =>
                                    <Button variant="outline-secondary" style={{ fontSize: "12px" }} key={i} onClick={() => loadTemplateData(rt)}>
                                        <BarChart size={18} />&nbsp;{rt.ReportTitle}
                                    </Button>
                                )}
                                <div style={{ width: "1px", border: "0.5px solid gray" }}></div>
                            </Fragment>
                        }
                    </ButtonGroup>
                    <Row style={{ margin: 0 }}>
                        <BihamtaTable columns={selectedColumns}
                            maxHeight={500}
                            filterData={filterData}
                            searchMethod={(data) => dispatch(getReportGeneratorReportData(data))}
                            reducerName="service"
                            objectName="reportGeneratorData"
                            hasPaging={true}
                            pageSizeList={[10, 20, 100, 500]}
                            defaultPageSize={500}
                            tableRef={tblResult} searchable className="mt-0 mb-0" style={{ whiteSpace: "nowrap", margin: 0, width: "100%" }} />
                    </Row>
                </Card.Body>
            </Card>
        </div>);
}